// extracted by mini-css-extract-plugin
export default {"main":"CertificateOverview_main__OVqkv","button":"CertificateOverview_button__Lh9b8"};